export const APP_VERSION = '1.1.1';
export const VIDEO_STATUSES = [
    'uploaded',
    'processing',
    'ready',
    'expired',
    'deletion_pending',
    'deleted',
    'failed'
];
